import script from "./ShowActivationsEventsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowActivationsEventsModal.vue?vue&type=script&setup=true&lang=js"

export default script